import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-h6 q-pb-md q-pa-md"
}
const _hoisted_2 = {
  key: 2,
  class: "q-px-md q-pb-md q-pt-md"
}
const _hoisted_3 = {
  key: 3,
  class: "q-px-md q-pb-md"
}
const _hoisted_4 = {
  key: 4,
  class: "q-px-md"
}
const _hoisted_5 = {
  key: 5,
  class: "row q-px-md"
}
const _hoisted_6 = { class: "q-pt-md col-6 q-pr-sm" }
const _hoisted_7 = { class: "q-pt-md col-6 q-pl-sm" }
const _hoisted_8 = {
  key: 6,
  class: "row q-px-md"
}
const _hoisted_9 = { class: "q-pt-md col-6 q-pr-sm" }
const _hoisted_10 = { class: "q-pb-xs text-overline text-dark text-uppercase" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 7,
  class: "row q-px-md"
}
const _hoisted_13 = { class: "q-pt-md col-6 q-pr-sm" }
const _hoisted_14 = { class: "q-pt-md col-6 q-pl-sm" }
const _hoisted_15 = { class: "q-pt-md col-6 q-pr-sm" }
const _hoisted_16 = { class: "q-pt-md col-6 q-pl-sm" }
const _hoisted_17 = {
  key: 8,
  class: "q-pt-md q-px-md q-pb-md"
}

import { PropType, ref, watch, onMounted, computed } from "vue";
  import { QSelect, QInput } from "quasar";
  
  import { LoanApplication } from "src/types/loan-application/index";
  import { ProductType_Enum } from "src/types/enums/product-type";
  import { ProductTypeOptions } from "src/const/select-options";
  import { TermOptions } from "src/const/select-options"
  import CurrencyInput from "src/components/form/inputs/CurrencyInput.vue";
  import DataTable from "src/components/form/forms/DataTable.vue";
  import { useProposalStore } from "src/stores/proposal-store";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'FinanceDetailsForm',
  props: {
    proposal: {
      type: Object as PropType<LoanApplication>,
      default: {} as LoanApplication
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    basic: {
      type: Boolean,
      default: false
    },
    isQuickQuote: {
      type: Boolean,
      default:false
    },
    readonly: {
      type: Boolean,
      default:false
    }
  },
  setup(__props, { expose: __expose }) {

  const props = __props
  
  const termSelect = ref<QSelect | null>(null)
  const depositInput = ref<QInput | null>(null)
  const pxInput = ref<QInput | null>(null)
  const settlementInput = ref<QInput | null>(null)
  const estInput = ref<QInput | null>(null)
  const pxRegInput = ref<QInput | null>(null)
  const pxMake = ref<QInput | null>(null)
  const pxModel = ref<QInput | null>(null)
  const pxMileageInput = ref<QInput | null>(null)
  const productTypeSelect = ref<QSelect | null>(null)
  const settlementFinanceCompanyInput = ref<QInput | null>(null)


  __expose({ validate });
  function validate() {
    let valid = true;
    depositInput.value!.validate() ? null : valid = false;
    pxInput.value!.validate() ? null : valid = false;
    settlementInput.value!.validate() ? null : valid = false;
    estInput.value!.validate() ? null : valid = false;
   
    if (props.proposal.pxValue && props.proposal.pxValue > 0 && props.isQuickQuote == false) {
      pxRegInput.value!.validate() ? null : valid = false;
      pxMileageInput.value!.validate() ? null : valid = false;
    }

    if (props.proposal.settlement && props.proposal.settlement > 0 && props.isQuickQuote == false)
    {
      settlementFinanceCompanyInput.value?.validate() ? null : valid = false;
    }

    if (!props.basic) {
      termSelect.value!.validate() ? null : valid = false;
      productTypeSelect.value!.validate() ? null : valid = false;
    }

    return valid;
  }

  function keyup(evt: KeyboardEvent) {
    evt.preventDefault();
  }

  watch(() => props.proposal.pxValue, (newValue) => {
    if (newValue === null || newValue <= 0) {
      resetInputs();
    }
  });

  function resetInputs() {
    pxRegInput.value = null;
    pxMileageInput.value = null;
    pxMake.value = null;
    pxModel.value = null;
    props.proposal.pxReg = null;
    props.proposal.pxMileage = null;
  }

  const formatValue = (value: number | null) => (value !== null ? "£" + value : "£0");

  const dataTableData = computed(() => {
    const productType = props.proposal.productType;
    // Determine if productType is a label or an enum value
    const isEnumValue = typeof productType === 'number';
    const productTypeLabel = isEnumValue
      ? ProductTypeOptions.find(option => option.value === productType)?.label || 'Unknown'
      : productType;

    let data = [
      { label: "Product Type:", value: productTypeLabel },
      { label: "Term (Months)", value: props.proposal.term != null ? props.proposal.term.toString() : null },
      { label: "Deposit", value: formatValue(props.proposal.deposit) }
    ] ;

    if (props.proposal.pxValue && props.proposal.pxValue > 0) {
      data.push(
        { label: "Px Value", value: formatValue(props.proposal.pxValue) },
        { label: "Px Registration", value: props.proposal.pxReg },
        { label: "Px Mileage", value: props.proposal.pxMileage != null ? props.proposal.pxMileage.toLocaleString() : 'Not provided' },
        { label: "Px Make", value: props.proposal.pxMake },
        { label: "Px Model", value: props.proposal.pxModel }        
      );
    }

    if (props.proposal.settlement && props.proposal.settlement > 0) {
      data.push(
        { label: "Settlement", value: formatValue(props.proposal.settlement) },
        { label: "Finance Company", value: props.proposal.settlementFinanceCompany }
      );
    }

    if(props.proposal.productType === ProductType_Enum.PCP){
      data.push(
        { label: "Annual Mileage", value: props.proposal.vehicle.annualMileage != null ? props.proposal.vehicle.annualMileage.toLocaleString() : useProposalStore().defaultPcpMileage.toLocaleString() }
      );
    }

    return data;
  });

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.showTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Finance Details "))
      : _createCommentVNode("", true),
    (__props.showTitle)
      ? (_openBlock(), _createBlock(_component_q_separator, { key: 1 }))
      : _createCommentVNode("", true),
    (!__props.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Product Type", -1)),
          _createVNode(_unref(QSelect), {
            modelValue: __props.proposal.productType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.proposal.productType) = $event)),
            options: _unref(ProductTypeOptions),
            ref_key: "productTypeSelect",
            ref: productTypeSelect,
            rules: [val => val !== null && val !== undefined || 'Required'],
            "emit-value": "",
            "popup-content-class": "text-body2",
            "map-options": "",
            outlined: "",
            dense: ""
          }, null, 8, ["modelValue", "options", "rules"])
        ]))
      : _createCommentVNode("", true),
    (!__props.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Term (months) *", -1)),
          _createVNode(_unref(QSelect), {
            modelValue: __props.proposal.term,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.proposal.term) = $event)),
            options: _unref(TermOptions),
            ref_key: "termSelect",
            ref: termSelect,
            rules: [val => !!val || 'Required'],
            "emit-value": "",
            "popup-content-class": "text-body2",
            "map-options": "",
            outlined: "",
            dense: ""
          }, null, 8, ["modelValue", "options", "rules"])
        ]))
      : _createCommentVNode("", true),
    (!__props.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(CurrencyInput, {
            modelValue: __props.proposal.deposit,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.proposal.deposit) = $event)),
            ref_key: "depositInput",
            ref: depositInput
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [
              _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Deposit", -1)
            ])),
            _: 1,
            __: [19]
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (!__props.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(CurrencyInput, {
              modelValue: __props.proposal.pxValue,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.proposal.pxValue) = $event)),
              ref_key: "pxInput",
              ref: pxInput
            }, {
              default: _withCtx(() => _cache[20] || (_cache[20] = [
                _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Part Ex. Value", -1)
              ])),
              _: 1,
              __: [20]
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(CurrencyInput, {
              modelValue: __props.proposal.settlement,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.proposal.settlement) = $event)),
              ref_key: "settlementInput",
              ref: settlementInput
            }, {
              default: _withCtx(() => _cache[21] || (_cache[21] = [
                _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Part Ex. Settlement", -1)
              ])),
              _: 1,
              __: [21]
            }, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    (!__props.readonly && __props.proposal.settlement && __props.proposal.settlement > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[22] || (_cache[22] = _createTextVNode(" Finance Company ")),
              (!__props.isQuickQuote)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "*"))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_unref(QInput), {
              outlined: "",
              modelValue: __props.proposal.settlementFinanceCompany,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((__props.proposal.settlementFinanceCompany) = $event)),
              ref_key: "settlementFinanceCompanyInput",
              ref: settlementFinanceCompanyInput,
              rules: __props.isQuickQuote ? [] : [val => !!val || 'Required'],
              "hide-spin-buttons": "",
              onWheel: _cache[6] || (_cache[6] = ($event: any) => ($event.target.blur())),
              onKeydown: [
                _withKeys(keyup, ["up"]),
                _withKeys(keyup, ["down"])
              ],
              dense: ""
            }, null, 8, ["modelValue", "rules"])
          ])
        ]))
      : _createCommentVNode("", true),
    (!__props.readonly && __props.proposal.pxValue && __props.proposal.pxValue > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Part Ex. Registration", -1)),
            _createVNode(_unref(QInput), {
              outlined: "",
              modelValue: __props.proposal.pxReg,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((__props.proposal.pxReg) = $event)),
              ref_key: "pxRegInput",
              ref: pxRegInput,
              rules: __props.isQuickQuote ? [] : [val => !!val || 'Required'],
              "hide-spin-buttons": "",
              onWheel: _cache[8] || (_cache[8] = ($event: any) => ($event.target.blur())),
              onKeydown: [
                _withKeys(keyup, ["up"]),
                _withKeys(keyup, ["down"])
              ],
              dense: ""
            }, null, 8, ["modelValue", "rules"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Part Ex. Mileage", -1)),
            _createVNode(_unref(QInput), {
              outlined: "",
              modelValue: __props.proposal.pxMileage,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((__props.proposal.pxMileage) = $event)),
              ref_key: "pxMileageInput",
              ref: pxMileageInput,
              rules: __props.isQuickQuote ? [] : [val => (val !== null && val !== '') || 'Required', val => (val >= 0) || 'Must be greater than or equal to 0'],
              type: "number",
              min: "0",
              suffix: "miles",
              "hide-spin-buttons": "",
              onWheel: _cache[10] || (_cache[10] = ($event: any) => ($event.target.blur())),
              onKeydown: [
                _withKeys(keyup, ["up"]),
                _withKeys(keyup, ["down"])
              ],
              dense: ""
            }, null, 8, ["modelValue", "rules"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Part Ex. Make", -1)),
            _createVNode(_unref(QInput), {
              outlined: "",
              modelValue: __props.proposal.pxMake,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((__props.proposal.pxMake) = $event)),
              ref_key: "pxMake",
              ref: pxMake,
              "hide-spin-buttons": "",
              onWheel: _cache[12] || (_cache[12] = ($event: any) => ($event.target.blur())),
              onKeydown: [
                _withKeys(keyup, ["up"]),
                _withKeys(keyup, ["down"])
              ],
              dense: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Part Ex. Model", -1)),
            _createVNode(_unref(QInput), {
              outlined: "",
              modelValue: __props.proposal.pxModel,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((__props.proposal.pxModel) = $event)),
              ref_key: "pxModel",
              ref: pxModel,
              "hide-spin-buttons": "",
              onWheel: _cache[14] || (_cache[14] = ($event: any) => ($event.target.blur())),
              onKeydown: [
                _withKeys(keyup, ["up"]),
                _withKeys(keyup, ["down"])
              ],
              dense: ""
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    (!__props.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Est. Annual Mileage", -1)),
          _createVNode(_unref(QInput), {
            outlined: "",
            modelValue: __props.proposal.vehicle.annualMileage,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((__props.proposal.vehicle.annualMileage) = $event)),
            modelModifiers: { number: true },
            ref_key: "estInput",
            ref: estInput,
            rules: [val => (val !== null && val !== '') || 'Required', val => (val >= 0) || 'Must be greater than or equal to 0'],
            type: "number",
            min: "0",
            suffix: "miles",
            "hide-spin-buttons": "",
            onWheel: _cache[16] || (_cache[16] = ($event: any) => ($event.target.blur())),
            onKeydown: [
              _withKeys(keyup, ["up"]),
              _withKeys(keyup, ["down"])
            ],
            dense: ""
          }, null, 8, ["modelValue", "rules"])
        ]))
      : _createCommentVNode("", true),
    (__props.readonly)
      ? (_openBlock(), _createBlock(DataTable, {
          key: 9,
          data: dataTableData.value
        }, null, 8, ["data"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})